export default function Hero() {
  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden bg-black">
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/b58423ed8dbec69ff13f877be134fa33/ac4501e23f4faa24439fb75c6f633f0c.jpeg"
          alt="Tank background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-black/75"></div>
      </div>

      <div className="relative z-10 text-center px-6 w-full max-w-5xl mx-auto">
        <h2 className="text-6xl md:text-8xl font-bold text-white mb-6" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.02em' }}>
          CHOKE POINT
        </h2>
        <p className="text-xl md:text-2xl text-white/95 mb-4 font-medium">
          The Ultimate Strategic Board Game Experience
        </p>
        <p className="text-base md:text-lg text-white/85 mb-10 max-w-2xl mx-auto leading-relaxed">
          Navigate tactical warfare, control critical positions, and outmaneuver your opponents in this intense strategy game from FishBox Studios
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button className="bg-orange-600 text-white px-8 py-4 rounded-md text-base font-bold whitespace-nowrap cursor-pointer">
            Coming Soon to Crowdfunding
          </button>
          <button className="bg-white/10 backdrop-blur-sm text-white border-2 border-white px-8 py-4 rounded-md text-base font-bold hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer">
            Learn More
          </button>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-4xl text-white/70"></i>
      </div>
    </section>
  );
}